export * from './Star30mm';